import React  from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import MarkerIcon from 'react-icons/lib/ti/location-outline';
import {getDisplayLocation} from '../../utils/location';
import { styles } from './styles';

const defaultIcon = <MarkerIcon style={{paddingBottom: 3}} />;

/**
 * Component that prints location string. Also has url to navigate to search
 * @param {string} city
 * @param {string} state
 * @param {string} country
 * @param {string} searchType events|unclaimed|athletes
 * @param {object} style To Override styles
 * @param {XML} icon [OPTIONAL] MarkerIcon
 *
 * @constructor
 */
function Location({ city, state, country, searchType, style, icon = defaultIcon }) {
  const locationText = getDisplayLocation(city, state, country);

  const link = `/search/${searchType}/?locationTerm=${locationText}`;

  const inner =
    <div style={styles.location.container(style)}>
      {icon}
      <span id="location">{locationText}</span>
    </div>;

  return searchType ? <Link to={link}>{inner}</Link> : inner
}

Location.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
  searchType: PropTypes.oneOf([ 'events', 'unclaimed', 'athletes' ]),
  style: PropTypes.object,
  icon: PropTypes.node,
};

export { Location }



/** WEBPACK FOOTER **
 ** ./components/shared/Location.js
 **/